import { Tabs } from 'antd'
import React, { ReactElement, useState } from 'react'
import { RechargeRecord } from './exchangeRecord/RechargeRecord'
import { ConsumptionRecord } from './exchangeRecord/ConsumptionRecord'
import { ExchangeRecord } from './exchangeRecord/ExchangeRecord'
import styles from './ExchangeRecordPage.module.css'

const { TabPane } = Tabs

export const ExchangeRecordPage = (): ReactElement => {
  const [activeTab, setActiveTab] = useState('0')

  return (
    <div className={styles.wrap}>
      <Tabs
        className={styles.tabs}
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
        destroyInactiveTabPane
      >
        <TabPane tab="充值明细" key="0">
          <RechargeRecord />
        </TabPane>
        <TabPane tab="消费明细" key="1">
          <ConsumptionRecord />
        </TabPane>
        <TabPane tab="会员明细" key="2">
          <ExchangeRecord />
        </TabPane>
      </Tabs>
    </div>
  )
}
